module.exports = __webpack_public_path__ + "static/media/COUNCILOR.21a569ef.svg";